<template>
  <div class="term_box">
    <div style="margin-bottom: 120px;">
      <HomeHeader />
    </div>

    <div class="term_contetn">
      <div></div>
      <div style="padding: 0 35px;">
        <div>
          <p>筑店提醒您：</p>
          <p>在使用筑店前，请您务必仔细阅读并透彻理解本协议。您可以主动取消或停止使用筑店提供的服务，但如果您使用筑店服务，您的使用行为将被视为对本协议</p>
          <p>全部内容的认可。</p>
        </div>

        <div class="term_title">
          筑店服务协议
        </div>

        <div>
          <div class="term_item">
            <p>第一条 特别提示</p>
            <p>深圳市科坦科技有限公司（以下简称“本公司”）通过小程序为用户提供预订住宿服务，住宿服务由住宿提供方提供。在通过酒店智能预订服务平台向本公司
              预订开始前，请仔细阅读本须知，本须知及产品页面中的重要条款作为本公司与预订人（下方所称“您”，代以“您”统称入住人和预订人应知晓和遵守的内
              容）双方协议的重要内容。当您勾选同意并进一步预订本产品时，表明您仔细阅读并接受协议的所有条款。本公司提供网络预订服务，帮助您向住宿提供方预
              订客房，本公司并不经营住宿业务。</p>
          </div>

          <div class="term_item">
            <p>第二条 预订注意事项</p>
            <p>1.科坦的酒店价格包含酒店服务费，但不含酒店内消费的其他费用。</p>
            <p>2. 您提出的特殊需求酒店方不能保证实现， 我们会及时将确认情况反馈给您。</p>
            <p>3. 订单需等酒店或供应商确认后生效， 订单确认结果以短信或邮件通知为准。</p>
            <p>4. 请在填写订单时， 务必留下准确的联系方式： 电话、 Email等， 以便客服与您联系预订相关事宜。</p>
            <p>5. 您在订单中填写的最晚到达时间如有变化， 请及时与科坦客服联系。 </p>
          </div>

          <div class="term_item">
            <p>第三条 订单生效</p>
            <p>订单生效后，您可以在入住前通知本公司更改或取消您所做预订，取消和更改订单需遵循预订流程中已披露的取消政策，可能依照政策产生相应违约费用。</p>
          </div>

          <div class="term_item">
            <p>第四条 您主动更改或取消已生效订单</p>
            <p>订单生效的定义：产品预订成功后，本公司通过酒店智能预订服务平台给您发送确认信息，该订单即生效。</p>
          </div>

          <div class="term_item">
            <p>第五条 不可抗力</p>
            <p>因不可抗力(包括地震、台风、雷击、水灾、火灾等自然原因，以及战争、政府行为、黑客攻击、电信部门技术管制等原因)不能履行或不能继续履行已生效
              订单约定内容的，本公司和您均不承担违约责任，但法律另有规定的除外。</p>
          </div>

          <div class="term_item">
            <p>第六条 争议解决</p>
            <p>在您的预订生效后，如果在订单约定内容履行过程中，您对相关事宜的履行发生争议，您同意按照中华人民共和国颁布的相关法律法规来解决争议，并同意
              接受深圳市宝安区人民法院的管辖。</p>
          </div>

          <div class="term_item">
            <p>第七条 其它</p>
            <p>本须知未尽的其他事项，由双方协商解决。</p>
          </div>



        </div>

        <div class="term_title">
          筑店隐私政策
        </div>

        <div>
          <div class="term_item">
            <p>一、我们如何收集和使用您的个人信息</p>
          </div>

          <div class="term_item">
            <p>1.酒店业务：</p>
            <p>为了您顺利预订酒店，在预订酒店时，需要您提供入住人姓名、手机号、邮箱、入离店时间。</p>
          </div>

          <div class="term_item">
            <p>2.常用信息：</p>
            <p>在您添加常用住客信息以便于快捷添加入住人信息时，需要提供姓名、手机号码、邮箱等。</p>
            <p>在您申请开具发票并添加发票抬头时，需要提供公司名称、纳税人识别号信息。</p>
          </div>

          <div class="term_item">
            <p>如果您不提供上述信息，您将无法享受我们提供的上述具体业务服务。</p>
          </div>

          <div class="term_item">
            <p>二、如何联系我们</p>
            <p>您可以通过发送邮件至我们客服邮箱：customerservice@cozy-time.com，或拨打我们的客服热线0755-27904330等方式与我们联系。</p>
            <p>以下为正文：</p>
          </div>

          <div class="term_item">
            <p>提示条款：</p>
            <p>感谢您对我方的信任，我们深知个人信息对您的重要性，我们将按法律法规要求，采取严格的安全保护措施，保护您的个人隐私信息。在此，我们郑重地</p>
            <p>提醒您：</p>
          </div>

          <div class="term_item">
            <p>1.在使用我方提供的服务时，您应当详细的阅读本用户隐私政策，详细了解我方收集、存储、使用、披露和保护您的个人信息的举措，进而帮助您更好的保
              护您的隐私。</p>
            <p>2.根据相关法律法规要求，网络产品、服务具有收集用户信息的功能，其提供者应当向用户明示并取得同意。我方特通过本用户隐私政策明确向您告知，并
              请您知晓我方如何使用用户的必要信息，进而为您提供更好的服务。</p>
            <p>3.在使用我方各项产品或服务前，请务必仔细阅读并透彻理解该用户隐私政策，如果您不同意本隐私政策的任何内容，您应当立即停止使用我方平台服务。
              当您使用我方提供的服务时，即表示您已同意我们按照本用户隐私政策来合法收集、使用和保护您的个人信息。如果您对本政策内容有任何疑问、意见或者
              建议，你可以及时通过第二条所列的方式与我们取得联系</p>
            <p>4.为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随之我们可能会不时退出新的或优化后的功能，可能需要收集、使用新的个人信息
              或变更个人信息使用的目的或方式。在此过程中，如果您对相关事宜有任何的疑惑，可以及时与我们取得联系，我们会为您尽快做出解答。</p>
          </div>
        </div>
      </div>
      <div></div>
    </div>

    <div>
      <ContantUs />
      <FooterInfo />
    </div>
  </div>
</template>

<script>
import HomeHeader from './components/HomeHeader.vue';
import ContantUs from './components/ContantUs.vue';
import FooterInfo from '../frame/footerInfo.vue';
export default {
  components: { HomeHeader, ContantUs, FooterInfo }
}
</script>

<style lang="less" scoped>
.title_style {
  font-size: 30px;
  color: #1e50f0;
  font-weight: bold;
  margin: 50px 0 40px 0;
}

.sub_content {
  margin-bottom: 40px;
}

.term_box {
  min-height: 100vh;

  .term_contetn {
    display: grid;
    grid-template-columns: auto 1180px auto;

    font-size: 16px;

    p {
      margin-bottom: 10px;
      font-family: '微软雅黑';
      line-height: 30px;
    }

    .term_title {
      .title_style();
    }

    .term_item {
      .sub_content();
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/TermsofService.vue